import LanguageDropdown from "components/Language/LanguageDropdown"
import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import {Message, Menu, Modal, Button, TabPane, Table} from "semantic-ui-react"
import {Row, Col, Form, FormField, FormInput} from "elemental-react16"
import {withRouter} from "react-router"
import queryString from "qs"
import "pages/Login.css"
import shop from "shop/shop"
import WordPressContainer from "WordPressContainer"
import config from "config"
import Responsive                                                from "react-responsive"
import NewCustomerPage from "./NewCustomerPage"
import ResetPasswordPage from "./ResetPasswordPage"
import NewCustomerContactPage from "./NewCustomerContactPage"

@withRouter
export default class LoginPage extends Component {
	constructor() {
		super()
		this.state = {
			user    : "",
			password: "",
			login: true,
			register: false,
			resetPW: false,
			customerRegister: false,
		}
		shop.whoami()
	}
	
	componentDidMount() {
		const {history} = this.props
		console.log("LoginPage mounted", this.props)
		if (this.props.location.search && this.props.location.search.endsWith("login")) {
			this.setState({
				login: true,
			})
		}
		if (this.props.location.search && this.props.location.search.endsWith("register")) {
			this.setState({
				register: true,
				login: false,
			})
		}
	}

	handleLogin = ( e ) => {
		const {history} = this.props
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		console.log( {query} )
		const {referrer} = query
		shop.loginOrfix( {...this.state} )
			.catch( ( err ) => {
				console.error( err )
				shop.toast( translate( "Fehler bei der Anmeldung" ), "error" )
				return false
			} )
			.then ( async session => {
				if ( !session ) return
				await this.handleSetOrderList()
				shop.loadCategories()
				await shop.cart.hydrateLogin()
				shop.toast( `${translate("Willkommen")} ${session.value.title ? session.value.title : ""}` )
				let redirectTo = referrer || shop.locationAfterLogin
				const handId    = session.handId;
				if (handId && handId != '') {
					redirectTo = "/login/accounts/"
				  }

				console.log( "AFTER", redirectTo )
				console.log( "AFTER", shop.locationAfterLogin, referrer, query , history)
				if ( redirectTo && redirectTo !== "/login/" && redirectTo !== "/login" && redirectTo !== "/login?referrer=login" && redirectTo !== "/login?referrer=login/"
					&& redirectTo !== "/register" && redirectTo !== "/register" && redirectTo !== "/register?referrer=register" && redirectTo !== "/register?referrer=register/"
					&& redirectTo !== "/home/login/" && redirectTo !== "/home/login"
				 ) {
					history.push( redirectTo )
				} else {
					history.push( "/home" )
				}
			} )

		e.preventDefault()
	}

	handleSetOrderList = async () => {
		let { currentList } = shop.store.orderlist
		console.log("currentList", currentList, JSON.stringify(shop.orderlist.lists), shop.orderlist.lists.Standard)
		if(shop.orderlist && shop.orderlist.lists && shop.orderlist.lists.Standard && shop.orderlist.lists.Standard.title == "Standard" && currentList == false){
			console.log("Setting current list to Standard", shop.orderlist.lists.Standard)
			shop.store.orderlist.setCurrentList( shop.orderlist.lists.Standard )
		}
	}

	handleUserChange = ( event ) => {
		this.setState( {
			user: event.target.value
		} )
	}

	handlePasswordChange = ( event ) => {
		this.setState( {
			password: event.target.value
		} )
	}



	handleTabButtons = (name ) => {
		if (name === "login") {
			this.setState({
				login: true,
				register: false
			})
		} else if (name === "register") {
			this.setState({
				login: false,
				register: true
			})
		}
	}


	render() {
		const { login, register, resetPW, customerRegister } = this.state
		console.log("this.props", this.props)
		const query = queryString.parse( this.props.location.search.substr( 1 ) )

		return (<Fragment>
			<Responsive minWidth={1100}>
				<div className="loginPageBackground ">
				<Row>
					<Col sm="4/12">

					</Col>
					<Col sm="8/12">
				<div className="LoginPage ">
				<div className=" container">
					<div className="black absolute top-0 right-2 pt2">
						{/*<LanguageDropdown />*/}
					</div>

					<section className="">

					

					<WordPressContainer postType={"shop"} slug={"login"} />

					<Row>
						<Col sm="2/12">	</Col>
						<Col sm="2/12">						<div className="relative ">
							<div className="absolute top-0 left-0">			  </div>
						</div> </Col>
						<Col sm="5/12">
							<div className="pb4" >
							<Link className={"logo"} to="/home/">
								<img
								src={shop.config.logo}
								alt="" />
							</Link>
							</div>
						<div className="flex flex-row justify-center " >
							
							<div  style={{width: "300px", borderBottom: "2px solid rgb(201, 201, 201)"}}></div>
							<div className=" pb2" style={{borderBottom: `${login ? "2px solid #a2cf66" : "2px solid rgb(201, 201, 201)"}`}}>
							<button  className="buttonLoginPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${login ? "none" : "none"}`, 
								backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("login")}><span className="pa2 fw6 f4">{translate("Anmelden")}</span></button></div>
								<div className=" pb2" style={{borderBottom: `${register ? "2px solid #a2cf66" : "2px solid rgb(201, 201, 201)"}`}}>
							<button className="buttonLoginPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${register ? "none" : "none"}`, 
								backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("register")}><span className="pa2 fw6 f4">{translate("Registrieren")}</span></button></div>
								<div className="" style={{width: "300px", borderBottom: "2px solid rgb(201, 201, 201)"}}></div>
						</div>
						{register && <Fragment>
							<NewCustomerPage />
							<div className="tc ">
							<div className="flex flex-row justify-center pt3"  >
						<div className="pr1 fw7 f6">{translate( "Sie haben bereits ein Konto?" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" onClick={() => this.handleTabButtons("login")}>{translate( "Hier anmelden" )}</Link> <br />
						{config.customer_enabling &&
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" to="/customer_enabling">{translate( "access with offline account" )}</Link>}
						</div>
						
					</div></Fragment>}
					{login && <Fragment>

						<div className="flex flex-row justify-center pa3" >
							<p className="fw7 pa3"><h1 className="fw7">{translate("Melden Sie sich an")}</h1></p>
						</div>
						<div className="flex flex-row justify-center pb2" >
							<p className="fw6 f5 black-50">{translate("loginHint")} </p>
						</div>

							<div className="">
								<Form onSubmit={this.handleLogin}>
									<FormField label={translate("Benutzer")} style={{width: "100%", borderRadius: "35px", backgroundColor: "#F8F7EC"}}
											   title={translate("Anmeldung mit E-Mail-Adresse oder Kunden-Nr.")}
											   htmlFor="basic-form-input-email">
										<FormInput style={{width: "100%", borderRadius: "35px", backgroundColor: "#ffffff"}} value={this.state.user}
												   onChange={this.handleUserChange}
												   type="text"
												   placeholder={ translate("E-Mail-Adresse / Kunden-Nr.")}
												   name="basic-form-input-id" />
									</FormField>
									<FormField label={translate("Passwort")}
											   htmlFor="basic-form-input-password">
										<FormInput value={this.state.password}
												   onChange={this.handlePasswordChange}
												   type="password"
												   placeholder={translate("Passwort")}
												   name="basic-form-input-password" />
									</FormField>
									{/*<FormField>*/}
									{/*<Checkbox label="Login speichern" />*/}
									{/*</FormField>*/}
									<div className="tc pt3 pb3">
										<Button style={{width: "100%", borderRadius: "35px", height: "50px"}}
											primary
											submit
										>{translate( "Anmelden" )}</Button>
										<Link className="db mt3 fw7 f6" style={{color: "#a2cf66"}}
											  onClick={() => {this.setState({resetPW: !resetPW})}}>{translate( "Passwort vergessen" )}?</Link>
											  {resetPW && <div className="pb3 pt3"><ResetPasswordPage /></div>}
									</div>
								</Form>
							</div>
						<div className="tc ">
							<div className="flex flex-row justify-center pt3" style={{ borderTop: "2px solid rgb(201, 201, 201)"}} >
						<div className="pr1 fw7 f6">{translate( "loginpage.noaccounthint" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6"  onClick={() => this.handleTabButtons("register")}>{translate( "loginpage.registerlink" )}</Link> <br />
						{config.customer_enabling &&
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" to="/customer_enabling">{translate( "access with offline account" )}</Link>}
						</div>
					</div>
					</Fragment>}
					<div className="flex flex-row justify-center pt2"  >
						<div className="pr1 fw7 f6">{translate( "loginpage.alreadycustomer" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" onClick={() => this.setState({customerRegister: true})}>{translate( "loginpage.requestlogin" )}</Link> <br />
						<Modal style={{ borderRadius: 20,}} className="ModalLoginPage"  open={customerRegister} onClose={() => this.setState({ customerRegister: false})}>
							<Modal.Header>
							<div className="flex flex-row justify-between items-center">
								<div>{translate( "Zugang anfordern" )}</div>
								<Button basic circular
										onClick={() => {
										this.setState({ customerRegister: false})
										}}
										icon="times"
								/>
							</div>
							
							</Modal.Header>
							<Modal.Content>
										<NewCustomerContactPage closeModal={true} onCloseModal={() => this.setState({ customerRegister: false })} />
							</Modal.Content>
						</Modal>
						</div>
						</Col>
					</Row>
					</section>

					{config.b2cLink && <div>
						<hr />
						<div className="tc">
							<a href={config.b2cLink}>{translate( "B2C Shop" )}</a>
						</div>
					</div>}
				</div>

				<div className=" fixed bottom-0 left-0 right-0" >

					<Menu fluid
						  secondary
						  size="small">
						<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "data"} )}}
								   position="right">{translate( "Data Policy" )}</Menu.Item>
						<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "imprint"} )}}>{translate( "imprint" )}</Menu.Item>
						<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "agb"} )}}>{translate( "AGB" )}</Menu.Item>
					</Menu>

				</div>


				<Modal
					open={query.modal && query.slug}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug={query.slug} />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "data"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="datenschutz" />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "imprint"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="impressum" />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "agb"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="agb" />
					</Modal.Content>
				</Modal>
			</div>
					</Col>
				</Row>
				</div>

				</Responsive>
			<Responsive maxWidth={1099}>
				<div className="loginPageBackgroundMobile">
				<div className="LoginPageMobile pa3">
					<div className="tc">
						<div className="pb3" >
											<Link className={"logo"} to="/home/">
											  <img
												src={shop.config.logo}
												alt="" />
											</Link>
											</div>
					</div>
<div className="flex flex-row justify-center" >
							<div  style={{width: "300px", borderBottom: "2px solid rgb(201, 201, 201)"}}></div>
							<div className=" pb2" style={{borderBottom: `${login ? "2px solid #a2cf66" : "2px solid rgb(201, 201, 201)"}`}}>
							<button  className="buttonLoginPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${login ? "none" : "none"}`, 
								backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("login")}><span className="pa2 fw6 f4">{translate("Anmelden")}</span></button></div>
								<div className=" pb2" style={{borderBottom: `${register ? "2px solid #a2cf66" : "2px solid rgb(201, 201, 201)"}`}}>
							<button className="buttonLoginPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${register ? "none" : "none"}`, 
								backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("register")}><span className="pa2 fw6 f4">{translate("Registrieren")}</span></button></div>
								<div className="" style={{width: "300px", borderBottom: "2px solid rgb(201, 201, 201)"}}></div>
						</div>
						{register && <Fragment>
							<NewCustomerPage />

							<div className="tc pb5">
							<div className="flex flex-row justify-center pt3"  >
						<div className="pr1 fw7 f6">{translate( "Sie haben bereits ein Konto?" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" onClick={() => this.handleTabButtons("login")}>{translate( "Hier anmelden" )}</Link> <br />
						{config.customer_enabling &&
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" to="/customer_enabling">{translate( "access with offline account" )}</Link>}
						</div>
					</div></Fragment>}
					{login && <Fragment>

						<div className="flex flex-row justify-center pa3" >
							<p className="fw7 pa3"><h1 className="fw7">{translate("Melden Sie sich an")}</h1></p>
						</div>
						<div className="flex flex-row justify-center pb2" >
							<p className="fw6 f5 black-50">{translate("Geben Sie Ihre E-Mail und Ihr Passwort ein.")} </p>
						</div>

							<div className="">
								<Form onSubmit={this.handleLogin}>
									<FormField label={translate("Benutzer")} style={{width: "100%", borderRadius: "35px", backgroundColor: "#F8F7EC"}}
											   title={translate("Anmeldung mit E-Mail-Adresse oder Kunden-Nr.")}
											   htmlFor="basic-form-input-email">
										<FormInput style={{width: "100%", borderRadius: "35px", backgroundColor: "#ffffff"}} value={this.state.user}
												   onChange={this.handleUserChange}
												   type="text"
												   placeholder={ translate("E-Mail-Adresse / Kunden-Nr.")}
												   name="basic-form-input-id" />
									</FormField>
									<FormField label={translate("Passwort")}
											   htmlFor="basic-form-input-password">
										<FormInput value={this.state.password}
												   onChange={this.handlePasswordChange}
												   type="password"
												   placeholder={translate("Passwort")}
												   name="basic-form-input-password" />
									</FormField>
									{/*<FormField>*/}
									{/*<Checkbox label="Login speichern" />*/}
									{/*</FormField>*/}
									<div className="tc pt3 pb3">
										<Button style={{width: "100%", borderRadius: "35px", height: "50px"}}
											primary
											submit
										>{translate( "Anmelden" )}</Button>
										<Link className="db mt3 fw7 f6" style={{color: "#a2cf66"}}
											  onClick={() => {this.setState({resetPW: !resetPW})}}>{translate( "Passwort vergessen" )}?</Link>
											  {resetPW && <div className="pb3 pt3"><ResetPasswordPage /></div>}
									</div>
								</Form>
							</div>
						<div className="tc pb5">
							<div className="flex flex-row justify-center pt3" style={{ borderTop: "2px solid rgb(201, 201, 201)"}} >
						<div className="pr1 fw7 f6">{translate( "Sie haben kein Konto?" )} </div>
						<Link style={{color: "#a2cf66"}} className=" fw7 f6"  onClick={() => this.handleTabButtons("register")}>{translate( "Hier registrieren" )}</Link> <br />
						{config.customer_enabling &&
						<Link style={{color: "#a2cf66"}} className=" fw7 f6" to="/customer_enabling">{translate( "access with offline account" )}</Link>}
						</div>
					</div>
					</Fragment>}
			</div>
				</div>

						
				</Responsive>
		</Fragment>
		)
	}
}




// WEBPACK FOOTER //
// ./src/theme/demo2025/pages/LoginPage.js